import type { CatalogProductImage, CatalogProductImageType } from '~/modules/catalog/api'

/** Сколько картинок показываем в карточке списка без раскрытия галереи */
export const CATALOG_CARD_PREVIEW_COUNT = 3

export const CATALOG_NO_IMAGE_SRC = '/img/catalog/no_img.jpg'
export const CATALOG_NO_IMAGE_SMALL_SRC = '/img/catalog/no_img_small.png'

export type CatalogCardVisibleImage = {
  type: CatalogProductImageType
  /** Превью в карточке */
  src: string
  /** Полный размер для просмотрщика */
  original: string
}

const isLegendImage = (image: CatalogProductImage) => image.type === 'legend'

/** Легенда идёт первой: и в карточке списка, и в галерее товара */
export const sortLegendImagesFirst = (
  images: CatalogProductImage[] | null | undefined
): CatalogProductImage[] => {
  if (!Array.isArray(images)) return []
  return [...images].sort(
    (left, right) => Number(isLegendImage(right)) - Number(isLegendImage(left))
  )
}

/**
 * Картинки для карточки списка.
 * Достаточно любой из ссылок: часть позиций приходит только с `img_mini`.
 */
export const getVisibleCatalogCardImages = (
  images: CatalogProductImage[] | null | undefined
): CatalogCardVisibleImage[] =>
  (images ?? []).flatMap(image => {
    const original = image.url?.img || image.url?.img_mini
    if (!original) return []

    return [{
      type: image.type,
      src: image.url?.img_mini || original,
      original
    }]
  })
